import axios from 'axios'

// export const otpClient = axios.create(
//     {
//         baseURL: process.env.NODE_ENV === "development" ? 'http://192.168.61.35:8086' : 'https://govahi.hovita.ir'
//     })
// export const apiClient = axios.create(
//     {
//         baseURL: process.env.NODE_ENV === "development" ? 'http://192.168.61.35:8086' : 'https://govahi.hovita.ir'
//     }
// )

export const otpClient = axios.create(
    {
        baseURL: process.env.NODE_ENV === "development" ? 'https://api.gavahit.com' : 'https://api.gavahit.com'
    })
export const apiClient = axios.create(
    {
        baseURL: process.env.NODE_ENV === "development" ? 'https://api.gavahit.com' : 'https://api.gavahit.com'
    }
)